import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import KeywordTable from '~/javascript/components/negative_keywords/keyword_table.vue'

export default class extends Controller {
  static values = {
    initialKeywords: Array,
    upsertUrl: String,
    deleteUrlBase: String,
    csrfToken: String,
    defaultMatchType: String
  }

  connect() {
    this.vue = createApp(KeywordTable, {
      initialKeywords: this.initialKeywordsValue,
      upsertUrl: this.upsertUrlValue,
      deleteUrlBase: this.deleteUrlBaseValue,
      csrfToken: this.csrfTokenValue,
      defaultMatchType: this.defaultMatchTypeValue
    })
    this.vue.mount(this.element)
  }

  disconnect() { this.vue?.unmount() }
}
